import { app_route_ids, app_route_keys } from "constants/urlPaths";
import { CHANNEL_KEYS } from "../../../utils/ManageBrandedCommunity.data";
import {
  getChannels,
  mapChannelsNameToUuids,
  mapMembershipNameToUuids,
} from "./ManageMembers.utils";
import { MEMBER_ROLE_TYPE } from "features/BrandedCommunity/constants/BrandedCommunity.constants";
import { is_empty } from "features/Common/utils/common.utils";
import { DEFAULT_MEMBERSHIP_LIST_SIZE } from "features/ManageOfferings/modules/MembershipsSection/constants/MembershipsSection.data";

const pathName = app_route_ids[app_route_keys.manage_branded_community_members];

export const MANAGE_MEMBERS_RA_PROPS = {
  basePath: pathName,
  history: {
    location: {
      pathname: pathName,
      search: "",
      hash: "",
    },
  },
  location: {
    pathname: pathName,
    search: "",
    hash: "",
  },
  match: {
    path: pathName,
    url: pathName,
    isExact: true,
    params: {},
  },

  resource: pathName,
  hasList: true,
  hasEdit: false,
  hasShow: false,
  hasCreate: false,
  syncWithLocation: false,
  perPage: 50,
};

export const MEMBER_KEYS = {
  dateJoined: "date_joined",
  memberName: "member_name",
  memberUsername: "member_username",
  memberEmail: "member_email",
  phoneNumber: "phone_number",
  totalBonusOfferings: "total_bonus_offerings",
  purchaseCount: "purchase_count",
  profilePic: "profile_pic",
  onlineStatus: "online_status",
  description: "description",
  channelUuid: "channel_uuid",
};

export const filterKeys = {
  memberName: "guest_name",
  phoneNumber: "phone_number",
  email: "email",
  channelUuid: "channel_uuid",
  channelType: "channel_type",
  membershipUuid: "membership_uuid",
};

export const getMembershipListOptions = ({ membershipList }) => {
  return (membershipList.list || []).map((membership) => {
    return {
      label: membership?.title,
      value: membership?.uuid,
    };
  });
};

export const filterConfig = ({ groups, membershipList }) => {
  const channels = getChannels(groups);
  const channelsOptions =
    channels?.map((channel) => ({
      id: channel[CHANNEL_KEYS.uuid],
      label: channel[CHANNEL_KEYS.name],
      value: [
        {
          name: filterKeys.channelType,
          value: channel[CHANNEL_KEYS.channelType],
        },
        {
          name: filterKeys.channelUuid,
          value: channel[CHANNEL_KEYS.uuid],
        },
      ],
    })) || [];

  return [
    {
      source: filterKeys.memberName,
      placeholder: "Name",
      type: "input",
      disableContains: true,
    },
    {
      source: filterKeys.email,
      placeholder: "Email",
      type: "input",
      disableContains: true,
    },
    {
      source: filterKeys.phoneNumber,
      placeholder: "Phone number",
      type: "input",
      disableContains: true,
    },
    {
      source: filterKeys.channelUuid,
      placeholder: "Channel",
      type: "dropdown",
      disableContains: true,
      options: channelsOptions,
    },
    ...(membershipList &&
    !is_empty(membershipList) &&
    membershipList.listSize > DEFAULT_MEMBERSHIP_LIST_SIZE
      ? [
          {
            source: filterKeys.membershipUuid,
            placeholder: "Membership",
            type: "dropdown",
            disableContains: true,
            options: getMembershipListOptions({ membershipList }),
          },
        ]
      : []),
  ];
};

export const tableChipsFormatter = ({ groups, membershipList }) => {
  const channels = getChannels(groups);
  const channelsUuidNameMap = mapChannelsNameToUuids(channels);
  const membershipsUuidNameMap = mapMembershipNameToUuids(
    membershipList?.list || []
  );

  return (filter, value) => {
    switch (filter) {
      case filterKeys.memberName:
        return `Name: ${value}`;
      case filterKeys.email:
        return `Email: ${value}`;
      case filterKeys.phoneNumber:
        return `Phone number: ${value}`;
      case filterKeys.channelUuid:
        return `Channel: ${channelsUuidNameMap[value]}`;
      case filterKeys.channelType:
        return null;
      case filterKeys.membershipUuid:
        return `Membership: ${membershipsUuidNameMap[value]}`;
      default:
        return undefined;
    }
  };
};

export const resetStorage = () => {
  sessionStorage.removeItem(MANAGE_MEMBERS_STORAGE_KEYS.CHANNEL_TYPE);
  sessionStorage.removeItem(MANAGE_MEMBERS_STORAGE_KEYS.CHANNEL_UUID);
};

export const MANAGE_MEMBERS_STORAGE_KEYS = {
  CHANNEL_UUID: "channel_uuid",
  CHANNEL_TYPE: "channel_type",
};

export const MEMBER_ROLE_TYPE_OPTIONS = [
  { label: "Member", value: MEMBER_ROLE_TYPE.NORMAL_CUSTOMER },
  { label: "Moderator", value: MEMBER_ROLE_TYPE.MODERATOR },
];
